export enum KlaviyoMetricType {
	CHECKOUT_COMPLETED = 'CHECKOUT_COMPLETED',
	CHECKOUT_STARTED = 'CHECKOUT_STARTED',
	EVENT_REGISTRATION_CANCELLED_EMAIL = 'EVENT_REGISTRATION_CANCELLED_EMAIL',
	EVENT_REGISTRATION_CONFIRMATION_EMAIL = 'EVENT_REGISTRATION_CONFIRMATION_EMAIL',
	INVOICE_EMAIL = 'INVOICE_EMAIL',
	MASTERCLASSES_BOTH_COMPLETED = 'MASTERCLASSES_BOTH_COMPLETED',
	NEWSLETTER_SIGNUP_EMAIL = 'NEWSLETTER_SIGNUP_EMAIL',
	PAYMENT_FAILED = 'PAYMENT_FAILED',
	PLAN_EXTENDED = 'PLAN_EXTENDED',
	PLAN_PURCHASED = 'PLAN_PURCHASED',
	PLAN_UPGRADED = 'PLAN_UPGRADED',
	PROGRAMME_COMPLETED = 'PROGRAMME_COMPLETED',
	QUIZ_PASSED = 'QUIZ_PASSED',
	SECOND_MASTERCLASS_PURCHASED = 'SECOND_MASTERCLASS_PURCHASED',
	SUBSCRIPTION_ACCESS_ENDED_EMAIL = 'SUBSCRIPTION_ACCESS_ENDED_EMAIL',
	SUBSCRIPTION_CANCELLED_EMAIL = 'SUBSCRIPTION_CANCELLED_EMAIL',
	SUBSCRIPTION_EXPIRED_TODAY = 'SUBSCRIPTION_EXPIRED_TODAY',
	SUBSCRIPTION_EXPIRING_IN_30_DAYS_EMAIL = 'SUBSCRIPTION_EXPIRING_IN_30_DAYS_EMAIL',
	SUBSCRIPTION_EXPIRING_IN_8_WEEKS_EMAIL = 'SUBSCRIPTION_EXPIRING_IN_8_WEEKS_EMAIL',
	SUBSCRIPTION_EXPIRING_SOON_EMAIL = 'SUBSCRIPTION_EXPIRING_SOON_EMAIL',
	SUBSCRIPTION_EXPIRING_TOMORROW_EMAIL = 'SUBSCRIPTION_EXPIRING_TOMORROW_EMAIL',
	SUBSCRIPTION_RENEWAL_FAILED_EMAIL = 'SUBSCRIPTION_RENEWAL_FAILED_EMAIL',
	SUBSCRIPTION_RENEWED_EMAIL = 'SUBSCRIPTION_RENEWED_EMAIL',
	SUBSCRIPTION_RENEWING_IN_30_DAYS_EMAIL = 'SUBSCRIPTION_RENEWING_IN_30_DAYS_EMAIL',
	SUBSCRIPTION_RENEWING_SOON_EMAIL = 'SUBSCRIPTION_RENEWING_SOON_EMAIL',
	SUBSCRIPTION_RENEWING_TOMORROW_EMAIL = 'SUBSCRIPTION_RENEWING_TOMORROW_EMAIL',
	TRIAL_PURCHASED = 'TRIAL_PURCHASED',
	USER_REQUEST_RESET = 'USER_REQUEST_RESET',
	WELCOME_EMAIL = 'WELCOME_EMAIL',
}
